<mat-card appearance="outlined" class="mat-sub-card">
  <mat-card-title>Caratteristiche Istanza</mat-card-title>
  <mat-card-content>
    <div class="row mb-3">
      <div class="col-24 col-sm-8 mt-2">
        <ng-container *ngTemplateOutlet="item; context: { icon: 'event', title: 'Scadenza', content: expiresOnTemplate }"></ng-container>
        <ng-template #expiresOnTemplate>{{ licenseInstance.expiresOn | date : 'shortDate' }}</ng-template>
      </div>

      @if (licenseInstance.operatingSystemVersion) {
      <div class="col-24 col-sm-8 mt-2">
        <ng-container
          *ngTemplateOutlet="
            item;
            context: { icon: 'computer', title: 'Sistema Operativo(Versione)[Architettura]:', content: operatingSystemVersionTemplate }
          "
        ></ng-container>
        <ng-template #operatingSystemVersionTemplate>
          {{ licenseInstance.operatingSystem }}
          @if (licenseInstance.operatingSystemVersion) {
          <span>({{ licenseInstance.operatingSystemVersion }})</span>
          } [{{ licenseInstance.operatingSystemArchitecture }}]
        </ng-template>
      </div>
      } @if (licenseInstance.runtime) {
      <div class="col-24 col-sm-8 mt-2">
        <ng-container
          *ngTemplateOutlet="item; context: { icon: 'update', title: 'Runtime(Versione):', content: runtimeTemplate }"
        ></ng-container>
        <ng-template #runtimeTemplate>{{ licenseInstance.runtime }}({{ licenseInstance.runtimeVersion }})</ng-template>
      </div>
      } @if (licenseInstance.container) {
      <div class="col-24 col-sm-8 mt-2">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <ng-container
            *ngTemplateOutlet="item; context: { icon: 'event', title: 'Container(Versione):', content: containerTemplate }"
          ></ng-container>
          <ng-template #containerTemplate>{{ licenseInstance.container }}({{ licenseInstance.containerVersion }})</ng-template>
        </div>
      </div>
      } @if (licenseInstance.cpuModel) {
      <div class="col-24 col-sm-8 mt-2">
        <ng-container *ngTemplateOutlet="item; context: { icon: 'build', title: 'Hardware', content: cpuModelTemplate }"></ng-container>
        <ng-template #cpuModelTemplate>
          <strong>CPU:</strong>
          {{ licenseInstance.cpuModel }}
          <br />
          <strong>Memoria:</strong>
          {{ licenseInstance.memory }}
          <br />
          <strong>Disco Libero:</strong>
          {{ licenseInstance.diskSpace }}
        </ng-template>
      </div>
      } @for (topInfo of stats?.topAttributes; track topInfo; let index = $index) {
      <div class="col-24 col-sm-8 mt-2">
        <ng-container
          *ngTemplateOutlet="item; context: { icon: 'settings', title: topInfo.label, content: topAttributesTemplate }"
        ></ng-container>
        <ng-template #topAttributesTemplate>
          {{ topInfo.value }}
        </ng-template>
      </div>
      }
    </div>

    <mat-accordion>
      <mat-expansion-panel class="mat-elevation-z0 bg-grey-light">
        <mat-expansion-panel-header>
          <mat-panel-title>Caratteristiche aggiuntive</mat-panel-title>
        </mat-expansion-panel-header>

        <div>
          <mat-list>
            @for (info of stats?.extraInfos; track info) {
            <mat-list-item>
              <h4 class="font-weight-bold" mat-line>{{ info.label }}</h4>
              <div mat-line>{{ info.value }}</div>
            </mat-list-item>
            }
          </mat-list>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>

<ng-template #item let-icon="icon" let-title="title" let-content="content">
  <div class="d-flex flex-column align-items-center justify-content-center h-100 border rounded p-3">
    <div class="d-flex align-items-center">
      <mat-icon>{{ icon }}</mat-icon>
      <h5 class="font-weight-bold m-0 ml-2">{{ title }}</h5>
    </div>
    <span class="mt-2 text-break">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </span>
  </div>
</ng-template>
